import { invoke } from '@shared/easyfy.decorators';
import '@clientShared/form';

@invoke
export default class ForgotPassword {
  constructor() {}

  onInit() {}
}
